import React from 'react';
import FBShareLinksSlideoutBannerNormalSrc from './FBShareLinksSlideoutBanner_normal.png';
import FBShareLinksSlideoutBannerWhiteSrc from './FBShareLinksSlideoutBanner_white.png';

export const FBShareLinksSlideoutBanner = ({
  textColor,
}: {
  textColor: 'white' | 'normal';
}) => {
  return textColor === 'white' ? (
    <img src={FBShareLinksSlideoutBannerWhiteSrc} />
  ) : (
    <img src={FBShareLinksSlideoutBannerNormalSrc} />
  );
};
